import { Injectable } from '@angular/core'
import { HttpClient, HttpHeaders, HttpResponse } from '@angular/common/http'
import { Observable } from 'rxjs'
import { EnvironmentService } from './environment.service'
import { CookieService } from 'ngx-cookie-service'

@Injectable({
  providedIn: 'root'
})
export class UsersApiService {
  private static readonly HTTP_OPTIONS = Object.freeze({
    headers: new HttpHeaders({
      'Content-Type': 'application/vnd.api+json',
      'Accept': 'application/vnd.api+json'
    }),
    observe: 'response' as 'body',
    responseType: 'json' as 'json',
    withCredentials: true
  })
  private _usersApiUrl: string

  constructor(
    private _http: HttpClient,
    private _environmentService: EnvironmentService,
    private _cookieService: CookieService
  ) {
    this._usersApiUrl = this._environmentService.get('USERS_API_URL')
  }

  public login(user: object): Observable<HttpResponse<object>> {
    return this._http.post<HttpResponse<object>>(
      this._usersApiUrl + '/login',
      this._formatRequestData(user),
      UsersApiService.HTTP_OPTIONS
    )
  }

  public signup(user: object, meta: object): Observable<HttpResponse<object>> {
    return this._http.post<HttpResponse<object>>(
      this._usersApiUrl,
      this._formatRequestData(user, meta),
      UsersApiService.HTTP_OPTIONS
    )
  }

  public dropOff(authToken: string, resumePath: string): Observable<HttpResponse<object>> {
    return this._http.post<HttpResponse<object>>(
      this._usersApiUrl + '/dropoff',
      this._formatRequestData({}, {
        'mp-auth-token': authToken,
        'resume-path': resumePath
      }),
      UsersApiService.HTTP_OPTIONS
    )
  }

  public loginWithAuthToken(): Observable<HttpResponse<object>> {
    return this._http.post<HttpResponse<object>> (
        this._usersApiUrl + '/login',
        this._formatRequestData({ token: this._getAuthToken() }),
        UsersApiService.HTTP_OPTIONS
    )
  }

  private _getAuthToken() {
    return this._cookieService.get('MP-AUTH-TOKEN')
  }

  private _formatRequestData(user: object, meta = {}): object {
    return {
      data: {
        type: 'users',
        attributes: user
      }, meta: meta
    }
  }
}
